import { createStore } from 'satcheljs';
export default createStore('replyOption', {
    replyAllByDefault: null,
})();
//# sourceMappingURL=store.js.map